import { StyleSheet, ViewStyle, TextStyle } from "react-native";
import { colors, fontSizes } from "../../../constants/styles";

interface TitleStyles {
  loginTitleContainer: ViewStyle;
  loginTitle: TextStyle;
}

interface ValidationErrorStyles {
  errorContainer: ViewStyle;
  errorLabel: TextStyle;
}

interface ErrorStyles {
  errorContainer: ViewStyle;
  noErrorContainer: ViewStyle;
  errorLabel: TextStyle;
}

interface LinkStyles {
  linkLabel: TextStyle;
}

export const titleStyles = StyleSheet.create<TitleStyles>({
  loginTitleContainer: {
    alignItems: "center",
  },
  loginTitle: {
    color: colors.cedar,
    paddingVertical: "5%",
    fontSize: fontSizes.x16,
    fontFamily: "HelveticaNeue-Medium",
    letterSpacing: 2,
  },
});

export const validationErrorStyles = StyleSheet.create<ValidationErrorStyles>({
  errorContainer: {
    alignItems: "center",
  },
  errorLabel: {
    color: colors.white,
    fontSize: fontSizes.x12,
    letterSpacing: 0,
  },
});

export const errorStyles = StyleSheet.create<ErrorStyles>({
  errorContainer: {
    minHeight: 30,
    alignItems: "center",
    justifyContent: "center",
    borderWidth: 1,
    marginBottom: 20,
    borderColor: "white",
    marginHorizontal: 10,
  },
  noErrorContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  errorLabel: {
    color: colors.white,
    fontSize: fontSizes.x12,
    letterSpacing: 0,
  },
});

export const linkStyles = StyleSheet.create<LinkStyles>({
  linkLabel: {
    color: colors.white,
    fontSize: fontSizes.x14,
    marginBottom: 20,
  },
});
